export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQ';

export const reset_pw_types = {
    RESET_PASSWORD_REQ_REQUEST: `${RESET_PASSWORD_REQUEST}_REQUEST`,
    RESET_PASSWORD_REQ_SUCCESS: `${RESET_PASSWORD_REQUEST}_SUCCESS`,
    RESET_PASSWORD_REQ_FAILURE: `${RESET_PASSWORD_REQUEST}_FAILURE`,
};


